export default __webpack_public_path__ + "static/media/brains.39846d7e.ico";